import { CommonModule } from "@angular/common";
import { Component, computed, input, signal, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatIcon } from "@angular/material/icon";
import { MatSliderModule } from "@angular/material/slider";
import { TranslocoPipe } from "@jsverse/transloco";
import { LorenDateModule } from "../../../../shared/pipes/loren-date/loren-date.module";

export interface CameraFrame {
  id: string | number;
  capturedAt: string;
  imageUrl: string;
  thumbnailUrl?: string;
}

type FrameId = CameraFrame["id"];

@Component({
  selector: "photo-player",
  imports: [
    CommonModule,
    FormsModule,
    MatIcon,
    MatSliderModule,
    TranslocoPipe,
    LorenDateModule,
  ],
  templateUrl: "./photo-player.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./photo-player.component.scss",
})
export class PhotoPlayerComponent {
  frames = input.required<CameraFrame[]>();
  title = input.required<string>();

  selectedFrameId = signal<FrameId | null>(null);

  maxIndex = computed<number>(() => Math.max(this.frames().length - 1, 0));

  currentIndex = computed<number>(() => {
    const idx = this.frames().findIndex((f) => f.id === this.selectedFrameId());

    return idx >= 0 ? idx : this.maxIndex();
  });

  currentFrame = computed<CameraFrame | null>(() => {
    const list = this.frames();
    return list.length ? list[this.currentIndex()] : null;
  });

  onSliderChange(index: number) {
    const frame = this.frames()[index];
    if (frame) this.selectedFrameId.set(frame.id);
  }
}
